import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {endpoints, types} from 'main/tools';

class GoalPageState {
  store = new DomainStore();
  scope;

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async load() {
    await this.store._compose([endpoints.PERFORMANCE_GOALS.NAVIGATION]);
    this.scope = this.store._getSingle(types.NAVIGATION_SCOPE).tabs;
  }
}

export default GoalPageState;
